import { Checkbox } from "react-migration/components/Checkbox/Checkbox";
import { FC } from "react";
import { TenureTypes } from "react-migration/domains/comparables/typings/Tenure";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { HMLRTenureShorthandGQL } from "react-migration/lib/typings/comparables/HMLR";
import { HometrackTenureShorthandGQL } from "react-migration/lib/typings/comparables/Hometrack";
import clsx from "clsx";

// hometrackV2: Delete "ANY" when beta gone
type TenureShorthandGQL = "Any" | HMLRTenureShorthandGQL | HometrackTenureShorthandGQL;

const TENURE_LABEL_KEYS: Record<TenureTypes, string> = {
  // hometrackV2: Delete when beta gone
  [TenureTypes.ANY]: "comparables.map.sidebar.filters.filters.tenure.any",
  [TenureTypes.FREEHOLD]: "comparables.map.sidebar.filters.filters.tenure.freehold",
  [TenureTypes.LEASEHOLD]: "comparables.map.sidebar.filters.filters.tenure.leasehold",
  [TenureTypes.SHARED]: "comparables.map.sidebar.filters.filters.tenure.shared",
};

export interface FilterTenureProps {
  disabled?: boolean;
  tenureTypes: Array<TenureShorthandGQL>;
  setTenureTypes: (values: Array<TenureShorthandGQL>) => void;
  availableTenures: TenureTypes[];
}

function toggleTenureType(
  currentTypes: Array<TenureShorthandGQL>,
  toggledOption: TenureShorthandGQL
): Array<TenureShorthandGQL> {
  const index = currentTypes.indexOf(toggledOption);

  if (index >= 0) {
    return currentTypes.filter((type) => type !== toggledOption);
  } else {
    return [...currentTypes, toggledOption];
  }
}

export const FilterTenure: FC<FilterTenureProps> = ({ disabled, tenureTypes, setTenureTypes, availableTenures }) => {
  const { t } = useTranslation();

  const updateTenureType = (type: TenureShorthandGQL) => {
    setTenureTypes(toggleTenureType(tenureTypes, type));
  };

  return (
    <div data-testid="filter-tenure" className="flex flex-col gap-1">
      <h4 className={clsx("m-0!", disabled && "text-text-base-primary-disabled")}>
        {t("comparables.map.sidebar.filters.filters.tenure.label")}
      </h4>
      <div className="flex flex-col gap-2 px-2">
        {availableTenures.map((tenureType) => (
          <div className="flex py-1 items-center h-7" key={tenureType}>
            <Checkbox
              disabled={disabled}
              id={`tenure-${tenureType.toLowerCase()}`}
              checked={tenureTypes.includes(tenureType)}
              onCheckedChange={() => updateTenureType(tenureType)}
            />
            <label className={clsx("pl-2", disabled && "text-text-base-primary-disabled")}>
              {t(TENURE_LABEL_KEYS[tenureType])}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
